function normalizeEpoch(epoch) {
  if (epoch == null) {
    console.log("epoch is null");
    return '';
  }
  
  // Convert to number first to handle decimal values
  const epochNum = Number(epoch);
  
  if (isNaN(epochNum)) {
    throw new Error(`Invalid epoch value: ${epoch}`);
  }
  
  // Check if epoch is in seconds (10 digits) or milliseconds (13 digits)
  // by comparing the magnitude rather than string length
  if (epochNum < 10000000000) {
    // Epoch is in seconds (less than 10 billion) → convert to milliseconds
    return epochNum * 1000;
  } else if (epochNum < 10000000000000) {
    // Epoch is in milliseconds (less than 10 trillion) → use as-is
    return epochNum;
  } else {
    // Epoch is in microseconds or nanoseconds → convert to milliseconds
    return Math.floor(epochNum / 1000);
  }
}
export function formatDate(newDate, type) {
  if (newDate === '' || newDate === 0) {
      return ''
  }
  const exacttime = normalizeEpoch(newDate);
const time = new Date(exacttime).toLocaleTimeString();
  const months = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December"
  };
  // const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  
  const d =  new Date(exacttime);
  const year = d.getFullYear();
  const date = d.getDate();
  // const monthIndex = d.getMonth();
  const monthName = months[d.getMonth()];
  // const dayName = days[d.getDay()]; // Thu

  const formatted = ` ${monthName} ${date}, ${year}`;
  if(type === 'invoice'){
    return formatted.toString() + " " + time;
  }else {
    return formatted.toString();
  }
}